import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CTAButton from './atoms/Button/CTAButton';
const CTA = ()=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-teal-700 px-4 py-20 text-center md:px-8",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-3xl",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "mb-4 text-4xl font-semibold tracking-tight text-white md:text-5xl",
                    children: "今すぐ記録を始める"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-8 text-xl text-teal-100 md:text-2xl",
                    children: "毎日続けなくても大丈夫。起きた時に、ワンタップで。"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ _jsx(CTAButton, {})
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mt-10 text-sm text-teal-200",
                    children: "iPhone / iPad (iOS 13.0以上) | Android (6.0以上)"
                })
            ]
        })
    });
};
export default CTA;
